import base64 from "Base64";

// 生成随机数
export function MathRand(sum = 5) {
    let Num = "";
    for (let i = 0; i < sum; i++) {
        Num += Math.floor(Math.random() * 10);
    }
    return Num;
}

// 创建hash
export function hashCode(str) {
    let h = 0,
        off = 0;
    const len = str.length;
    for (let i = 0; i < len; i++) {
        h = 31 * h + str.charCodeAt(off++);
    }
    const t = -2147483648 * 2;
    while (h > 2147483647) {
        h += t;
    }
    return h;
}

// 加密可以加密N次，对应解密N次就可以获取明文
export function encodeBase64(mingwen, times) {
    let [code, num] = ["", 1];
    if (typeof times == "undefined" || times == null || times == "") {
        num = 1;
    } else {
        const vt = `${times}`;
        num = parseInt(vt);
    }

    if (typeof mingwen == "undefined" || mingwen == null || mingwen == "") {
        console.log("mingwen == undefined");
    } else {
        code = mingwen;
        for (let i = 0; i < num; i++) {
            code = base64.btoa(code);
        }
    }
    return code;
}
// 加密可以加密N次，对应解密N次就可以获取明文
export function decodeBase64(mi, times) {
    let [mingwen, num] = ["", 1];
    if (typeof times == "undefined" || times == null || times == "") {
        num = 1;
    } else {
        const vt = `${times}`;
        num = parseInt(vt);
    }

    if (typeof mi == "undefined" || mi == null || mi == "") {
        console.log("mi == undefined");
    } else {
        mingwen = mi;
        for (let i = 0; i < num; i++) {
            mingwen = base64.atob(mingwen);
        }
    }
    return mingwen;
}
// 中文编码
export function toUnicode(str) {
    return escape(str)
        .toLocaleLowerCase()
        .replace(/%u/gi, "\\u");
}
// 中文解码
export function toGB2312(str) {
    return unescape(str.replace(/\\u/gi, "%u"));
}


const browser = {
    versions: (function () {
        const u = navigator.userAgent;
        console.log("u:", u);
        // const app = navigator.appVersion;
        return {
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
            iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
            weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
            qq: u.indexOf("QQ") != -1 //是否QQ
        };
    })(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
}

console.log("browser:", browser);

// 下载app
export function downloadapp() {
    const scheme = `iyaoho://start`;
    const times = 2000;
    if (browser.versions.mobile) {
        // 2019-12-04 取消QQ引导，
        // if (browser.versions.weixin || browser.versions.qq) {
        if (browser.versions.weixin) {
            window.$vVuer.show();
            return false;
        }
        if (browser.versions.ios || browser.versions.iPad || browser.versions.iPhone) {
            // 有APP直接跳，没有跳AppStore
            window.location.href = scheme;
            setTimeout(function () {
                window.location.href = 'https://apps.apple.com/cn/app/id1473895426';
            }, times);
        } else if (browser.versions.android) {
            window.location.href = scheme;
            // 应用宝链接
            setTimeout(function () {
                window.location.href = 'https://countryside.oss-cn-hangzhou.aliyuncs.com/yaoho/yaohe.apk';
            }, times);
        }
    } else {
        // pc下载
        // window.location.href = '下载页链接';
    }
}